<template>
  <div class="snail-riverMountain">
    <!-- 活动标题 -->
    <div v-wechat-title="'寻宝！蜗的华夏之旅'"></div>
    <div class="content-box">
      <!-- 头部登录切换 -->
      <Header :isOnline="1" :config="headerConfig" isShowInfo />
      <div class="swiper-container content-swiper-container">
        <div class="swiper-wrapper" id="swiper-content">
          <div class="swiper-slide swiper-slide-first">
            <div class="second-travel-title"></div>
            <div class="second-travel-box">
              <div class="btn-second-travel" @click="enterSecondTravel"></div>
              <div
                :class="['btn-yinhua', miles_status == 1 ? 'tip' : '']"
                @click="enterMission"
              ></div>
              <div class="btn-book" @click="enterBook"></div>
            </div>
          </div>
        </div>
        <div class="content-button-prev"></div>
        <div class="content-button-next" @click="handleIndexNext"></div>
      </div>
    </div>

    <!-- 首页进入青瓷游戏LOGO -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      name="fade"
    >
      <div
        @touchmove.prevent
        class="preloading preloading-snail"
        v-show="preloadingShow"
      ></div>
    </transition>

    <!-- 引导对话弹窗 -->
    <transition leave-active-class="animated fadeOut" name="fade">
      <div @touchmove.prevent class="guide-wrap popup_wrap" v-show="guideShow">
        <div class="btn-skip" @click="handleSkipClick"></div>
        <div class="dialog-text-box" v-show="showDialogText">
          <p v-html="currentDialogText"></p>
        </div>
        <div class="guide-box" v-show="showDialog">
          <div v-if="guideShow" class="dialogue-box">
            <h3>{{ guideRole }}</h3>
            <p v-html="currentWord"></p>
          </div>
          <span class="role-chunJi"></span>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            name="fade"
            :duration="{ leave: 800 }"
          >
            <div class="choices-box" v-if="showChoices">
              <div
                @click="onNextGuide(chunJiWords[currentWordIdx].btn1Key)"
                class="first-choice"
              >
                {{ chunJiWords[currentWordIdx].btn1Text }}
              </div>
              <div
                @click="onNextGuide(chunJiWords[currentWordIdx].btn2Key)"
                class="second-choice"
              >
                {{ chunJiWords[currentWordIdx].btn2Text }}
              </div>
            </div>
          </transition>
        </div>
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          name="fade"
          :duration="{ leave: 800 }"
        >
          <div class="dialog-end1-box" v-show="showEnd">
            <div class="end1-label"></div>
            <div :class="'end1-title ' + endResult"></div>
            <div class="end1-tip" v-show="endResult === 'noTime'">
              <span>冬眠蜗蜗</span><br />
              <span>大棉被一盖谁也不爱</span>
            </div>
            <div class="end1-tip" v-show="endResult === 'sleep'">
              <span>运动一下吧</span>
              <span>蜗壳都要长毛了</span>
            </div>
            <div class="end1-tip" v-show="endResult === 'noLeft'">
              <span>防晒对抗蜗的皮肤老化</span>
              <span>那也不能给小姬一瓶都用完啊</span>
            </div>
            <div class="dialogue-box">
              <!-- <h3>{{guideRole}}</h3> -->
              <p v-html="currentEndWord"></p>
            </div>
            <div
              class="btn-skip-end"
              v-if="dialogEnd"
              @click="handleSkipClick"
            ></div>
            <div
              class="btn-reDialog"
              v-if="dialogEnd"
              @click="handleReDialog"
            ></div>
          </div>
        </transition>
        <div class="close-bg" @click="closeDialogText()"></div>
      </div>
    </transition>

    <!-- 前导页 -->
    <transition
      :duration="{ enter: 100 }"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      name="fade"
    >
      <div
        @touchmove.prevent
        class="leading-wrap popup_wrap"
        v-show="leadingShow"
      >
        <div class="title"></div>
        <div class="dialog-snail-text-box" v-show="showSnailDialogText">
          <p v-html="currentSnailDialogText"></p>
        </div>
        <div class="dialog-chunji-text-box" v-show="showChunjiDialogText">
          <p v-html="currentChunjiDialogText"></p>
        </div>
        <div
          class="btn-start-travel"
          @click="startTravel"
          v-show="showBtnStart"
        ></div>
      </div>
    </transition>

    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      noAuthLogin
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色ID可在游戏中—蜗牛属性—蜗牛信息查看"
    >
    </Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
    >
    </Os>

    <!-- 第二期活动提示弹窗 -->
    <transition
      enter-active-class="animated zoomInNew"
      leave-active-class="animated zoomOutRight"
      :duration="{ enter: 1000 }"
    >
      <div class="second-travel-wrap popup_wrap" v-show="secondTravelShow">
        <div class="popup-wrap-box" v-show="secondTravelShow">
          <div class="btn-box">
            <a href="javascript:;" @click="secondTravelShow = false">确定</a>
          </div>
        </div>
        <div class="close-bg" @click="secondTravelShow = false"></div>
      </div>
    </transition>

    <!-- 里程碑和印花弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="milestone-wrap popup_wrap" v-show="showMilestoneModal">
        <div class="milestone-box">
          <div class="milestore-content-box">
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div class="total-mission-box">
                <div class="yinzhang-box">
                  <div
                    v-for="(item, index) in milestoneProgress"
                    :key="index"
                    @click="handleMissionItemClick(index)"
                    :class="[
                      item ? 'finished ' : '',
                      'total-mission-item',
                      `item-${index}`,
                      miles_status == 1 && index == 1 ? 'tip' : ''
                    ]"
                  >
                    <div class="img-item"></div>
                    <div class="name">{{ milestoneProgressText[index] }}</div>
                  </div>
                </div>
              </div>
            </transition>
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div
                v-show="currentIndex === 2 && showCurrentMission"
                class="mission-second-box"
              >
                <div class="yinhua-box">
                  <div
                    v-for="(item, index) in missionList[2]"
                    :key="'icon-' + index"
                    :class="[`status${item.status}`, 'mission-item-icon']"
                  ></div>
                </div>
                <div class="milestone-second-mission-box">
                  <div
                    v-for="(item, index) in missionList[2]"
                    :key="'mission-' + index"
                    class="mission-item"
                  >
                    <div class="mission-title">{{ item.name }}</div>
                    <div
                      :class="[`status${item.status}`, 'mission-status']"
                      @click="handleMissionGetClick(item)"
                    ></div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="btn-back" @click="handleMilestoneBack"></div>
          <div class="grey-bg"></div>
        </div>
      </div>
    </transition>

    <!-- 纪念册弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="book-wrap popup_wrap" v-show="showBookModal">
        <div class="book-content-box">
          <div :class="['book-box', bookClass]">
            <div id="turnpage" class="turnpage">
              <div class="book-cover">
                <p class="os shadow"></p>
                <p class="rid shadow"></p>
              </div>
              <div class="hard book-back"></div>
              <div
                :class="[
                  'sheet',
                  'page2',
                  'page3',
                  join_periods[0] ? '' : 'grey'
                ]"
              >
                <div class="content"></div>
                <div class="btn-prev" @click="prepage"></div>
                <div class="btn-next" @click="nextpage"></div>
              </div>
              <div class="hard book-back" />
              <!-- 第二期继续往这里加 -->
              <div
                :class="[
                  'sheet',
                  'page4',
                  'page5',
                  join_periods[1] ? '' : 'grey'
                ]"
              >
                <div class="content"></div>
                <div class="btn-prev" @click="prepage"></div>
                <div class="btn-next" @click="nextpage"></div>
              </div>
              <div class="hard book-back" />
              <!-- 第三期继续往这里加 -->
              <!-- <div
                :class="[
                  'sheet',
                  'page6',
                  'page7',
                  'grey'
                ]"
              >
                <div class="content"></div>
                <div class="btn-prev" @click="prepage"></div>
                <div class="btn-next" @click="nextpage"></div>
              </div>
              <div class="hard book-back" /> -->
            </div>
          </div>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            :duration="1000"
          >
            <div class="btn-open-book" v-show="showBtnOpen" @click="openBook" />
          </transition>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            :duration="1000"
          >
            <div
              class="btn-share-book"
              v-show="showBtnShare"
              @click="openShare"
            />
          </transition>
          <div class="btn-book-back" @click="closeBook" />
        </div>
        <div class="grey-bg"></div>
      </div>
    </transition>

    <!-- 第二期弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div
        class="secondTravel-wrap popup_wrap"
        v-show="showSecondTravelModal"
        @touchmove.prevent
      >
        <div class="secondTravel-content-box">
          <div class="second-travel-title"></div>
          <div
            :class="['qr-copy', 'monitor-btn', share ? 'got' : '']"
            @click="onCopy('index')"
            id="clipboard-btn"
            data-event="复制链接"
            :data-clipboard-text="url"
          ></div>
          <div :class="['content-detail', bookClass]">
            <div class="btn-play-intro" @click="showPlayWayIntro"></div>
            <div class="btn-show-activity" @click="showActivity"></div>
            <div class="btn-show-info" @click="showInformation"></div>
            <div
              :class="['btn-play', reward_list.includes(1) ? 'tip' : '']"
              @click="showGame"
            ></div>
          </div>
          <div class="btn-back" @click="handleFirstTravelBack"></div>
        </div>
      </div>
    </transition>

    <!-- 玩法介绍弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div
        class="play-way-intro-wrap popup_wrap"
        v-show="showPlayWayIntroModal"
      >
        <div class="play-way-box">
          <div class="play-way-content-box">
            <div
              class="play-way-swiper-container swiper-no-swiping swiper-container"
            >
              <div class="swiper-wrapper">
                <div class="swiper-slide slide1">
                  <div class="play-way-item-title">寒冬漠河行</div>
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <div class="text-content">
                      <div class="time">活动时间：12月22日-1月5日</div>
                      <p class="second-text">
                        投掷骰子一起出发吧！带上蜗牛和小伙伴，一起探索冰雪覆盖的神秘北极村
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide slide2">
                  <div class="play-way-item-title">漠河拼图</div>
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <div class="text-content">
                      <p>
                        北极村景色真漂亮，蜗要把一张张照片做成拼图挂在家里~
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide slide3">
                  <div class="play-way-item-title">冰湖钓鱼</div>
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <div class="text-content">
                      <p>
                        冬日垂钓是最大的挑战和乐趣了，看蜗意志力拉满，把漠河最大的鱼钓回家~
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination play-way-pagination"></div>
            </div>
            <div class="swiper-button-prev play-way-button-prev"></div>
            <div class="swiper-button-next play-way-button-next"></div>
          </div>
          <div class="btn-play-way-reward" @click="showAppReward = true" />
          <div class="btn-back" @click="handlePlayWayBack" />
        </div>
        <!-- <div class="close-bg" @click="showInformationModal = false"></div> -->
      </div>
    </transition>

    <!-- 游戏规则弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="game-rule-wrap popup_wrap" v-show="showGameRule">
        <div class="game-rule-box">
          <!-- <div class="game-rule-text-box">
            <div class="game-rule-text-content"></div>
          </div> -->
        </div>
        <div class="close-bg" @click="showGameRule = false"></div>
      </div>
    </transition>

    <!-- app内游戏奖励弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="app-reward-wrap popup_wrap" v-show="showAppReward">
        <div class="app-reward-box"></div>
        <div class="close-bg" @click="showAppReward = false"></div>
      </div>
    </transition>

    <!-- 复制链接成功弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="share-success-wrap popup_wrap" v-show="showShareModal">
        <div class="share-success-box">
          1
          <div class="btn-box">
            <a href="javascript:;" @click="showShareModal = false">确定</a>
          </div>
        </div>
        <div class="close-bg" @click="showShareModal = false"></div>
      </div>
    </transition>
    <!-- 福利活动列表弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="activity-wrap popup_wrap" v-show="showActivityModal">
        <div class="activity-box">
          <div class="activity-content-box">
            <div
              class="activity-swiper-container swiper-no-swiping swiper-container"
            >
              <div class="swiper-wrapper">
                <div class="swiper-slide slide1">
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <p>美丽的冬日之景让蜗灵感大爆发，</p>
                    <p>快来以画会友吧！</p>
                  </div>
                  <div class="btns-box">
                    <div
                      class="btn-enter-activity"
                      @click="enterActivity('erchuang')"
                    ></div>
                  </div>
                </div>
                <div class="swiper-slide slide2">
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <p>蜗和雪花有个约定~</p>
                    <p>快来分享你最喜欢的冬日活动吧</p>
                  </div>
                  <div class="btns-box">
                    <div
                      class="btn-enter-activity"
                      @click="enterActivity('huati')"
                    ></div>
                  </div>
                </div>
                <div class="swiper-slide slide3">
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <p>小姬和阿白还在公众号和TapTap</p>
                    <p>准备了福利！快来看看吧！</p>
                  </div>
                  <div class="btns-box">
                    <div
                      class="btn-left"
                      @click="enterActivity('wechat')"
                    ></div>
                    <div
                      class="btn-enter-activity"
                      @click="enterActivity('tap')"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination activity-pagination"></div>
            </div>
            <div class="swiper-button-prev activity-button-prev"></div>
            <div class="swiper-button-next activity-button-next"></div>
          </div>
          <div class="btn-back" @click="handleActivityBack" />
        </div>
        <!-- <div class="close-bg" @click="showActivityModal = false"></div> -->
      </div>
    </transition>
    <!-- 景区资料弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="information-wrap popup_wrap" v-show="showInformationModal">
        <div class="information-box">
          <div class="information-content-box">
            <div
              class="information-swiper-container swiper-no-swiping swiper-container"
            >
              <div class="swiper-wrapper">
                <div class="swiper-slide slide1">
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <div class="text-content">
                      <p>
                        漠河北极村景区雄居祖国的最北端，位于黑龙江上游南岸、大兴安岭山脉北麓，与俄罗斯隔黑龙江相望，是国家AAAAA级旅游景区，有着“金鸡之冠”、“神州北极”和“不夜城”的美誉。
                      </p>
                      <p>
                        其地理位置为北纬53°以上的高纬度地区，是全国唯一观赏北极光的最佳观测点。夏季白天通常长达17个小时以上，而冬季刚好相反，是北极村的一大特色。
                        北极村全年平均气温在-5℃左右，冬季的极端最低气温可降至-50℃。有着中国最北、神奇天象、极地冰雪等国内独特的资源景观。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide slide2">
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <div class="text-content">
                      <p>
                        北极村原为漠河村，1997年开辟为北极村旅游风景区。其包含了大大小小十余个景点，有着漠河市标志性建筑的北极星广场；与俄罗斯隔江相望的七星广场；集餐饮、住宿、观赏为一体的北极村接待中心；极具纪念意义的中国最北邮政局；展示鄂伦春民族风土人情的鄂伦春民族博物馆；有着木揢楞式小木屋的“中国最北一家”等。
                      </p>
                      <p>
                        北极村景区风景古风纯朴，静溢清新，乡土气息浓郁，植被和生态环境保存完好。每年都有很多从世界各地到这里的游客，感受中国极地风光与西方圣诞文化，体会最北的幸福。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide slide3">
                  <div class="info-img-box"></div>
                  <div class="text-box">
                    <div class="text-content">
                      <p>
                        漠河物产资源丰富，绿色环保无污染。在大兴安岭天然绿色生态屏障下，孕育着各种珍奇野味，如野生蘑菇、灵芝、黑木耳，还有哲罗、细鳞、重唇、鳇鱼等珍贵冷水鱼。美味的漠河烤狗鱼、风干香肠、铁锅炖也让食客们流连忘返。
                      </p>
                      <p>
                        北极村四时之景大不相同，夏季的北极村不仅是避暑的好去处，幸运的游客还能观赏到天幕上梦幻的极光，在冬季能体验到银装素裹，洁白纯净的雪国景象，冬季鱼类体型较大但行动缓慢，冰湖垂钓堪称最大的乐趣，游客们饱受收获的喜悦。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination information-pagination"></div>
            </div>
            <div class="swiper-button-prev information-button-prev"></div>
            <div class="swiper-button-next information-button-next"></div>
          </div>
          <div class="btn-back" @click="handleInfomationBack" />
        </div>
        <!-- <div class="close-bg" @click="showInformationModal = false"></div> -->
      </div>
    </transition>

    <!-- 第二期游戏弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="second-game-wrap popup_wrap" v-show="gameModal">
        <div class="second-game-box">
          <div class="second-game-content-box">
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div class="index-box" v-show="showGameIndex">
                <div
                  class="btn-show-game-rule"
                  @click="showGameRule = true"
                ></div>
                <div
                  :class="[
                    'btn-game-reward',
                    reward_list.includes(1) ? 'tip' : ''
                  ]"
                  @click="handleShowGameReward"
                ></div>
                <div class="btn-join-game" @click="handleJoinGame"></div>
              </div>
            </transition>
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div v-show="showQuestion">
                <div class="question-box" v-if="topic_list[topice_id]">
                  <div class="question-title">
                    {{ topic_list[topice_id].topic }}
                  </div>
                  <div class="question-options-box">
                    <div
                      v-for="(item, index) in optionList"
                      @click="answerQuestion(item.value, index)"
                      :key="'option-' + index"
                      :class="[
                        'question-option',
                        choosedOption === index ? 'choosed' : '',
                        isRight === 1 ? 'true' : isRight === 2 ? 'false' : ''
                      ]"
                    >
                      {{ item.key }}. {{ topic_list[topice_id][item.value] }}
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div class="game-reward-box" v-show="showGameReward">
                <div class="red-tip-box">
                  <div
                    v-for="(item, index) in reward_list"
                    :key="'status-' + index"
                    :class="[
                      'reward-item',
                      `reward-${item}`,
                      item === 1 ? 'tip' : ''
                    ]"
                  ></div>
                </div>
                <div
                  class="btn-share"
                  @click="onCopy('game')"
                  id="game-clipboard-btn"
                  data-event="复制链接"
                  :data-clipboard-text="url"
                ></div>
                <div :class="['reward-box', share ? 'got' : '']"></div>
              </div>
            </transition>
          </div>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
          >
            <div
              class="btn-get-reward"
              v-show="showBtnGetReward"
              @click="handleGetAnswerReward"
            ></div>
          </transition>
          <div class="btn-back" @click="handleGameBack"></div>
        </div>
        <!-- <div class="close-bg" @click="gameModal = false"></div> -->
      </div>
    </transition>

    <!-- 第一期照片分享弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="share-popup popup_wrap" v-show="shareShow">
        <div class="share-box popup_wrap-box">
          <img
            class="share-img"
            src="https://download4.qcplay.com/h5-images/active/snail/riverMountain-2/bg_share_first.png"
            v-if="!isSecondShare"
          />
          <img
            class="share-img"
            src="https://download4.qcplay.com/h5-images/active/snail/riverMountain-2/bg_share_second.png"
            v-if="isSecondShare"
          />
        </div>
        <div class="share-tip">长按上方图片保存，快去分享给好友吧！</div>
        <div class="close-bg" @click="shareShow = false"></div>
      </div>
    </transition>

    <!-- 第二期结束后回顾确认弹窗 -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div
        class="second-end-configm-wrap popup_wrap"
        v-show="showSecondEndConfirmModal"
      >
        <div class="second-end-configm-box">
          <div class="btn-confirm" @click="handleLookBackClick"></div>
        </div>
        <div class="close-bg" @click="showSecondEndConfirmModal = false"></div>
      </div>
    </transition>

    <!-- 阻止点击弹出-弹窗 -->
    <div
      @touchmove.prevent
      :class="'prevent-wrap prevent-wrap-' + preventShow"
    ></div>
  </div>
</template>
<script>
import { Indicator, Toast } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import _ from "lodash";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import Clipboard from "clipboard";

import Os from "@/components/os";
import turn from "@/assets/js/turn.js";
import Login from "@/components/login";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { headerConfig } from "../../headerConfig";
import {
  initUserinfo,
  getMilestone,
  initSecondTravelData,
  answer,
  getShareReward,
  getAnswerReward,
  getMissionReward
} from "../api";
import { analysisParams, getTimeStamp, buriedLogger } from "@/utils/utils";
import { generateCanvasImage } from "@/utils/share";

export default {
  name: "riverMountainIndex",
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      secondTravelShow: false, // 第二期活动未开始弹窗
      guideShow: false, // 对话
      currentWordIdx: "first", // 当前春姬说的话的key
      currentWord: "",
      guideRole: "春姬",
      chunJiWords: {
        first: {
          text: "蜗牛！你怎么知道我刚钓起来一条20斤的大鱼！",
          btn1Text: "啊？谁问你了",
          btn2Text: "大冬天的你搁哪钓的鱼",
          btn1Key: "tooBad",
          btn2Key: "tooBad"
        },
        tooBad: {
          text: "这不大冬天没事做嘛~刚好也到冰钓的时节了，小姬就去过了把瘾！",
          btn1Text: "还好你没想着把我丢下去打窝",
          btn2Text: "冰面上垂钓要注意安全哦...",
          btn1Key: "game",
          btn2Key: "game"
        },
        game: {
          text:
            "不过附近的池塘还挺小的，不如和小姬一起去远点的地方看看？就当是旅游了！",
          btn1Text: "你要带蜗去那浪漫的大东北？",
          btn2Text: "不要，蜗要冬眠！",
          btn1Key: "travel",
          btn2Key: "noTime"
        },
        reason: {
          text:
            "之前还听说，猴子在华夏旅游的时候，挖蛤蜊挖到个看似价格不菲的大宝贝，我们也去旅游吧~",
          btn1Text: "小姬确定只是去旅游吗......",
          btn2Text: "不去，蜗要睡觉",
          btn1Key: "travel",
          btn2Key: "sleep"
        },
        travel: {
          text:
            "是了！那边有雪景和冰雕看，又能在冰湖上钓鱼，说不定还有新的宝藏！一举多得呀！",
          btn1Text: "好主意！等蜗先收拾一下行李！",
          btn2Text: "然后手边再拿一杯82年的咖啡，啧啧...",
          btn1Key: "index",
          btn2Key: "index"
        },
        noTime: {
          text: "睡睡懒觉虽好，但户外运动更佳噢~"
        },
        sleep: {
          text: "我记得以前是八块腹肌，现在怎么一大块了......"
        },
        noLeft: {
          text: "防——晒——霜"
        }
      },
      dialogText:
        "某天下午B看着屋外下起小雪的蜗B准备钻进小被窝B正要回想华山的那趟旅程……",
      snailText: "那么，我们去哪......", // 前导页蜗牛的话
      chunjiText: "这次要去漠河玩咯！", // 前导页春姬的话
      currentDialogText: "",
      showDialogText: false,
      showDialog: false,
      dialoging: false,
      showChoices: false,
      dialogEnd: false,
      leadingShow: false,
      showSnailDialogText: false,
      showChunjiDialogText: false,
      currentSnailDialogText: "",
      currentChunjiDialogText: "",
      showBtnStart: false,
      headerConfig,
      gameName: "snail",
      downloadUrl: "https://static.qcplay.com/snail/official/",
      preloadingShow: true,
      preventShow: false,
      loginTypes: ["sms", "password", "channel"],
      user_activity: "",
      // userInfo: {},
      // 个人hash信息
      user_params: {
        role_id: "",
        token: "",
        game_id: "",
        server_id: "",
        os: "",
        web_bonus_id: "",
        zone: ""
      },
      showMilestoneModal: false,
      milestoneProgress: [],
      miles_status: 0, // 判断印花任务是否有可领取的
      missionList: {},
      showBookModal: false,
      showSecondTravelModal: false,
      url: "",
      showPlayWayIntroModal: false,
      showShareModal: false,
      showActivityModal: false,
      showInformationModal: false,
      currentIndex: 2, // 当前是第几期
      isSecondShare: false,
      gameModal: false, // 第一期游戏弹窗
      answer: 0, // 目前答对了几题
      is_red: false, // 奖励是否领取
      reward_list: [0, 0, 0, 0, 0], // 奖励列表1表示可以领了2表示领取了
      share: false, // 是否领取过分享奖励
      time: 0, // 答题次数
      topic_list: [], // 题目数组
      topice_id: 1, // 题目id
      answering: false, // 是否正在点击答案
      logger: null,
      shareShow: false,
      showBtnOpen: true,
      showBtnShare: false,
      showEnd: false,
      endResult: "",
      currentEndWord: "",
      showGameIndex: true, // 展示游戏框底图
      showQuestion: false, // 展示题目
      shareLink: "",
      showGameRule: false,
      showGameReward: false,
      showBtnGetReward: false, // 一键领取答题奖励按钮
      urlList: {
        erchuang: "https://tap.cn/qT3I6NiO?channel=rep-rep_qcbjf9x5zqy",
        huati: "https://tap.cn/xbfVLkRV?channel=rep-rep_uoispkdbwwp",
        wechat:
          "https://h5.qingcigame.com/package/index.html?id=39&area=QC-GAME",
        tap: "https://tap.cn/UH5tczqK?channel=rep-rep_7pth523sijc_h5url836"
      },
      showAppReward: false,
      milestoneProgressText: ["华山", "漠河", "", "", ""],
      showCurrentMission: false,
      indexSwiper: null,
      join_periods: [],
      timeList: {
        1: {
          start: "2023/08/25 10:00:00",
          end: "2023/09/08 23:59:59"
        },
        2: {
          start: "2023/12/22 10:00:00",
          end: "2024/01/05 23:59:59"
        }
      },
      timer: null,
      choosedOption: -1,
      isRight: 0, // 2表示错误，1表示正确，0表示初始
      optionList: [
        {
          key: "A",
          value: "answer_a"
        },
        {
          key: "B",
          value: "answer_b"
        },
        {
          key: "C",
          value: "answer_c"
        },
        {
          key: "D",
          value: "answer_d"
        }
      ],
      showSecondEndConfirmModal: false,
      bookClass: ""
    };
  },
  created() {},
  mounted() {
    // 适配问题
    const fitWidth = window.innerWidth;
    const fitHeight = window.innerHeight;
    const screenScale = Number((fitWidth / fitHeight).toFixed(3));
    console.log("scale", screenScale);
    // alert(screenScale)
    if (screenScale > 0.73) {
      this.bookClass = "scale-06";
    } else if (screenScale > 0.67) {
      this.bookClass = "scale-075";
    } else if (screenScale > 0.6) {
      this.bookClass = "scale-085";
    } else if (screenScale > 0.54) {
      // $('.container').addClass('scale-09');
    }

    this.url = `福利|最强蜗牛华夏寻宝之旅来啦！限定头像等你拿！https://h5.qingcigame.com/snail/riverMountain-2/enter${getTimeStamp()}`;
    this.shareLink = `https://h5.qingcigame.com/snail/riverMountain-2/enter${getTimeStamp()}`;
    // 获取uuid-api
    this.$nextTick(() => {
      // this.getParams()
      this.getLoginContainer();
      this.initFlipBook();
      this.isSetShare();
      this.initActivitySwiper();
      this.initContentBoxSwiper();
      this.initInformationSwiper();
      this.initPlayWaySwiper();
      // 埋点
      const bl = buriedLogger("snail", "riverMountain_page");
      this.logger = bl;
      setTimeout(() => {
        this.preloadingShow = false;
        this.starDialog();
        this.logger.sum("蜗牛全国巡游主题h5_第二期活动页统计");
      }, 500);
    });
  },
  methods: {
    handleSkipClick() {
      if (!this.guideShow) return;
      this.guideShow = false;
      localStorage.setItem("noShow", 1);
      this.startLeadingShow();
    },
    handleFirstTravelBack() {
      this.showSecondTravelModal = false;
      this.preventClick();
    },
    handlePlayWayBack() {
      this.showPlayWayIntroModal = false;
      this.preventClick();
    },
    handleActivityBack() {
      this.showActivityModal = false;
      this.preventClick();
    },
    handleInfomationBack() {
      this.showInformationModal = false;
    },
    handleLookBackClick() {
      this.showSecondEndConfirmModal = false;
      this.showSecondTravelModal = true;
    },
    handleIndexNext() {
      console.log("---", this.indexSwiper);
      this.indexSwiper && this.indexSwiper.slideNext();
    },
    myToast(text, time) {
      Toast({
        message: text,
        className: "my-snail-tip",
        duration: time || 2000
      });
    },
    handleMilestoneBack() {
      if (this.showCurrentMission) {
        this.showCurrentMission = false;
        return;
      }
      this.showMilestoneModal = false;
    },
    // 领取印花任务奖励
    handleMissionGetClick: _.throttle(
      function(item) {
        const { status, id } = item;
        if (status === 2 || status === 0) return;
        Indicator.open();
        getMissionReward({ task_id: id, periods: 2 })
          .then(res => {
            Indicator.close();
            if (res.code === 200) {
              this.initMilestone();
            } else {
              this.myToast(res.message);
            }
          })
          .catch(err => {
            Indicator.close();
            this.myToast("服务器出错啦");
          });
      },
      1000,
      { trailing: false }
    ),
    // 印花任务选择
    handleMissionItemClick(index) {
      if (index === 0) {
        if (this.currentEndTip(1));
      } else if (index === 1) {
        this.showCurrentMission = true;
      }
    },
    preventClick() {
      this.preventShow = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.preventShow = false;
      }, 1000);
    },
    startTravel() {
      this.leadingShow = false;
      this.logger.sum("蜗牛全国巡游主题h5_第二期开始旅行");
      this.preventClick();
    },
    printSnailText() {
      const text = this.snailText;
      const textArr = text.split("");
      const loop = () => {
        setTimeout(() => {
          const str = textArr.shift(0, 1);
          this.currentSnailDialogText += str;
          if (textArr.length !== 0) {
            loop();
          } else {
            setTimeout(() => {
              this.showChunjiDialogText = true;
              this.printChunjiText();
            }, 300);
          }
        }, 120);
      };
      loop();
    },
    printChunjiText() {
      const text = this.chunjiText;
      const textArr = text.split("");
      const loop = () => {
        setTimeout(() => {
          const str = textArr.shift(0, 1);
          this.currentChunjiDialogText += str;
          if (textArr.length !== 0) {
            loop();
          } else {
            this.showBtnStart = true;
          }
        }, 120);
      };
      loop();
    },
    printEndText(text) {
      const textArr = text.split("");
      const loop = () => {
        setTimeout(() => {
          const str = textArr.shift(0, 1);
          this.currentEndWord += str;
          if (textArr.length !== 0) {
            loop();
          } else {
            if (["noTime", "sleep", "noLeft"].includes(this.currentWordIdx)) {
              this.dialogEnd = true;
            }
          }
        }, 120);
      };
      loop();
    },
    // 进入第二期主题
    enterSecondTravel() {
      this.logger.sum("蜗牛全国巡游主题h5_进入第二期");
      const showTime = this.timeList[2].end;
      if (new Date(showTime).getTime() < new Date().getTime()) {
        this.showSecondEndConfirmModal = true;
        return;
      }
      this.showSecondTravelModal = true;
    },
    enterMission() {
      if (!this.userInfo.role_id) {
        this.myToast("请先登录", 1000);
        this.changeLoginPopup(true);
        return;
      }
      this.initMilestone();
      this.showMilestoneModal = true;
      this.logger.sum("蜗牛全国巡游主题h5_第二期进入印章页");
    },
    enterBook() {
      this.showBookModal = true;
      this.logger.sum("蜗牛全国巡游主题h5_第二期进入纪念册");
    },
    openBook() {
      if (!this.userInfo.role_id) {
        this.myToast("请先登录", 1000);
        this.changeLoginPopup(true);
        return;
      }
      if ($("#turnpage").turn("page") > 1) return;
      this.nextpage();
      this.showBtnOpen = false;
    },
    // 下一段指导
    onNextGuide(key) {
      if (this.clickNextGuide === false) {
        return;
      }
      this.logger.sum("蜗牛全国巡游主题h5_第二期点击对话");
      this.clickNextGuide = false;
      this.currentWord = "";
      this.currentWordIdx = key;
      this.showChoices = false;
      if (key === "index") {
        this.guideShow = false;
        localStorage.setItem("noShow", 1);
        this.startLeadingShow();
        return;
      } else if (key === "noTime" || key === "sleep" || key === "noLeft") {
        this.showDialog = false;
        this.showEnd = true;
        this.endResult = key;
        setTimeout(() => {
          this.printEndText(this.chunJiWords[key].text);
        }, 1500);
        return;
      }
      this.onPrint();
    },
    startLeadingShow() {
      this.leadingShow = true;
      // this.leadingShow = false
      setTimeout(() => {
        this.showSnailDialogText = true;
        this.printSnailText();
      }, 300);
    },
    // 开始引导动画
    starGuideAni: _.throttle(
      function() {
        // 重置
        this.clickNextGuide = false;
        this.showDialog = true;
        this.currentWordIdx = "first";
        this.currentWord = "";
        // this.wordColor = '';
        // this.guideShow = true
        setTimeout(() => {
          this.onPrint();
        }, 1700);
      },
      1000,
      { trailing: false }
    ),
    // 打印文字
    onPrint() {
      const text = this.chunJiWords[this.currentWordIdx].text || "";
      const textArr = text.split("");
      const loop = () => {
        setTimeout(() => {
          const str = textArr.shift(0, 1);
          this.jointWord(str);
          if (textArr.length !== 0) {
            loop();
          } else {
            this.clickNextGuide = true;
            this.showChoices = true;
          }
        }, 60);
      };

      loop();
    },
    // 组成文字
    jointWord(word) {
      if (word === "B") {
        this.currentWord += `<br />`;
      } else {
        this.currentWord += word;
      }
    },
    // 开始首次的文字出现
    starDialog() {
      if (localStorage.getItem("noShow")) {
        this.startLeadingShow();
        return;
      }
      this.logger.sum("蜗牛全国巡游主题h5_第二期进入前导页");
      this.guideShow = true;
      this.showDialogText = true;
      this.dialoging = true;
      setTimeout(() => {
        this.autoPrint();
      }, 500);
    },
    // 关闭首次的文字出现并开始引导动画
    closeDialogText() {
      if (this.dialoging || !this.showDialogText) return;
      this.showDialogText = false;
      this.starGuideAni();
    },
    // 打印初始文字
    autoPrint() {
      const text = this.dialogText;
      const textArr = text.split("");
      const loop = () => {
        setTimeout(() => {
          const str = textArr.shift(0, 1);
          if (str === "B") {
            this.currentDialogText += `<br />`;
          } else {
            this.currentDialogText += str;
          }
          if (textArr.length !== 0) {
            loop();
          } else {
            setTimeout(() => {
              this.dialoging = false;
            }, 500);
          }
        }, 80);
      };
      loop();
    },
    // 重新选择
    handleReDialog: _.throttle(
      function() {
        this.dialogEnd = false;
        this.showDialog = true;
        this.showEnd = false;
        this.showChoices = false;
        if (this.currentWordIdx === "noTime") {
          this.currentWordIdx = "game";
        } else if (this.currentWordIdx === "sleep") {
          this.currentWordIdx = "reason";
        } else if (this.currentWordIdx === "noLeft") {
          this.currentWordIdx = "travel";
        }
        this.currentWord = this.chunJiWords[this.currentWordIdx].text;
        setTimeout(() => {
          // this.onPrint()
          this.clickNextGuide = true;
          this.showChoices = true;
          this.currentEndWord = "";
          this.endResult = "";
        }, 1500);
      },
      1000,
      { trailing: false }
    ),
    // 获取hash参数
    getParams() {
      const params = analysisParams(window.location.href);
      this.user_params.role_id = params.role_id;
      this.user_params.token = params.token;
      this.user_params.game_id = params.game_id;
      this.user_params.server_id = params.server_id;
      this.user_params.os = params.os;
      this.user_params.web_bonus_id = params.web_bonus_id;
      this.user_params.zone = params.zone;
      if (params.role_id) {
        this.uuid();
      } else {
        this.getLoginContainer();
      }
    },
    uuid() {
      const host = window.location.host;
      const pathname = window.location.pathname;
      console.log(window.location.host);
      getUuidApi({ ...this.user_params }).then(response => {
        if (Number(response.code) == 200) {
          this.user_params.uuid = response.data.uuid;
          if (response.data.status == 1) {
            window.location.href = `//` + host + pathname + `${getTimeStamp()}`;
            return;
          }
        }
        if (Number(response.code) == 401) {
          // 开启弹窗
        }
        // id错误
        if (Number(response.code) == 405) {
          window.location.href = `//` + host + pathname + `${getTimeStamp()}`;
        }
      });
    },
    // 初始化角色信息
    getLoginContainer() {
      initUserinfo()
        .then(response => {
          if (Number(response.code) === 200) {
            // this.preloadingShow = false
            this.user_activity = response.data.activity;
            this.join_periods = response.data.activity.join_periods || [];
            this.onInitDataCallback(response);
            this.initMilestone();
            this.getFirstTravelData();
            return;
          }
          Number(response.code) !== 401 && this.myToast(response.message);
        })
        .catch(err => {
          this.myToast("服务器出错啦");
        });
    },
    // 初始化纪念册
    initFlipBook() {
      $("#turnpage").turn({
        elevation: 50,
        acceleration: true,
        display: "double",
        page: 1,
        gradients: true, // Enable gradients
        duration: 1000,
        when: {
          start: (e, pageConfig) => {
            const { page, next } = pageConfig;
            console.log(pageConfig, "pageConfig");
            if ((page === 2 && next === 1) || (page === 4 && next === 1)) {
              this.showBtnShare = false;
            }
          },
          turned: (e, pageIndex) => {
            console.log(pageIndex, "pageIndex");
            if (pageIndex === 1) {
              this.showBtnOpen = true;
            }
            if (pageIndex == 2 || pageIndex == 3 || pageIndex == 4) {
              this.showBtnShare = true;
            }
            if (pageIndex == 4) {
              this.isSecondShare = true;
            } else {
              this.isSecondShare = false;
            }
          }
        }
      });
    },
    closeBook() {
      if ($("#turnpage").turn("page") === 1) {
        this.showBookModal = false;
      } else {
        $("#turnpage").turn("page", 1);
      }
    },
    prepage() {
      $("#turnpage").turn("previous");
    },
    nextpage() {
      if ($("#turnpage").turn("page") >= 4) {
        this.myToast("敬请期待");
        return;
      }
      $("#turnpage").turn("next");
    },
    currentEndTip(index) {
      const showTime = this.timeList[index || 2].end;
      if (new Date(showTime).getTime() < new Date().getTime()) {
        this.myToast("活动已结束");
        return true;
      }
      return false;
    },
    // 复制链接
    onCopy(place) {
      if (!this.userInfo.role_id) {
        this.myToast("请先登录", 1000);
        this.changeLoginPopup(true);
        return;
      }
      if (this.currentEndTip(2)) return;
      let clipboard = null;
      if (place === "index") clipboard = new Clipboard("#clipboard-btn");
      if (place === "game") clipboard = new Clipboard("#game-clipboard-btn");
      const text = place === "index" ? "联动页" : "游戏内页";
      this.logger.sum(`蜗牛全国巡游主题h5_第二期${text}分享`);
      clipboard.on("success", e => {
        // this.showShareModal = true
        this.myToast("已成功复制分享链接，快分享给好友们吧！");
        clipboard.destroy();
        if (this.share) return;
        getShareReward()
          .then(res => {
            if (res.code === 200 || res.code === 405) {
              this.share = true;
            }
          })
          .catch(() => {
            this.myToast("服务器出错啦");
          });
        e.clearSelection();
      });
      clipboard.on("error", e => {
        this.myToast("复制失败");
        clipboard.destroy();
      });
    },
    // 展示玩法介绍
    showPlayWayIntro() {
      this.showPlayWayIntroModal = true;
      this.logger.sum("蜗牛全国巡游主题h5_第二期点击玩法介绍");
    },
    // 展示活动列表
    showActivity() {
      this.showActivityModal = true;
      this.logger.sum("蜗牛全国巡游主题h5_第二期点击福利活动");
    },
    // 展示景区资料
    showInformation() {
      this.showInformationModal = true;
      this.logger.sum("蜗牛全国巡游主题h5_第二期点击景区资料");
    },
    // 参与游戏
    handleJoinGame() {
      if (!this.userInfo.role_id) {
        this.myToast("请先登录", 1000);
        this.changeLoginPopup(true);
        return;
      }
      if (this.currentEndTip(2)) return;
      if (this.answer >= 5) {
        this.myToast("您已解锁所有答题奖励，请前往领取");
        return;
      }
      if (this.time <= 0) {
        this.myToast("今天没次数了，明天再来吧");
        return;
      }
      this.showGameIndex = false;
      this.showQuestion = true;
    },
    // 游戏弹窗的返回按钮
    handleGameBack() {
      this.preventClick();
      if (this.showQuestion) {
        this.showQuestion = false;
        this.showGameIndex = true;
        this.isRight = 0;
        this.choosedOption = -1;
        this.getFirstTravelData();
        return;
      }
      if (this.showGameReward) {
        this.showGameReward = false;
        this.showBtnGetReward = false;
        this.showGameIndex = true;
        return;
      }
      this.gameModal = false;
    },
    showGame() {
      if (!this.userInfo.role_id) {
        this.myToast("请先登录", 1000);
        this.changeLoginPopup(true);
        return;
      }
      this.logger.sum("蜗牛全国巡游主题h5_第二期点击趣味游戏");
      this.gameModal = true;
      this.showGameIndex = true;
      this.showQuestion = false;
      this;
    },
    // 初始化里程碑数据
    initMilestone() {
      getMilestone()
        .then(res => {
          if (Number(res.code) == 200) {
            this.milestoneProgress = res.data.milestone_schedule;
            this.missionList = res.data.current_schedule;
            this.miles_status = res.data.miles_status;
          } else {
            this.myToast(res.message);
          }
        })
        .catch(() => {
          this.myToast("服务器出错啦");
        });
    },
    initActivitySwiper() {
      new Swiper(".activity-swiper-container.swiper-container", {
        direction: "horizontal",
        slidesPerView: 1,
        pagination: ".activity-pagination.swiper-pagination",
        nextButton: ".activity-button-next.swiper-button-next",
        prevButton: ".activity-button-prev.swiper-button-prev",
        observer: true,
        observeParents: true
      });
    },
    // 初始化首页内容swiper
    initContentBoxSwiper() {
      this.indexSwiper = new Swiper(
        ".content-swiper-container.swiper-container",
        {
          direction: "vertical",
          slidesPerView: 1,
          allowSwipeToPrev: false,
          allowSwipeToNext: false
        }
      );
    },
    initInformationSwiper() {
      new Swiper(".information-swiper-container.swiper-container", {
        direction: "horizontal",
        slidesPerView: 1,
        pagination: ".information-pagination.swiper-pagination",
        nextButton: ".information-button-next.swiper-button-next",
        prevButton: ".information-button-prev.swiper-button-prev",
        observer: true,
        observeParents: true
      });
    },
    initPlayWaySwiper() {
      new Swiper(".play-way-swiper-container.swiper-container", {
        direction: "horizontal",
        slidesPerView: 1,
        pagination: ".play-way-pagination.swiper-pagination",
        nextButton: ".play-way-button-next.swiper-button-next",
        prevButton: ".play-way-button-prev.swiper-button-prev",
        observer: true,
        observeParents: true
      });
    },
    // 选择角色后
    selectCallback() {
      this.getLoginContainer();
    },
    osCancell() {
      console.log("注销");
      this.milestoneProgress = [0, 0, 0, 0, 0];
      this.miles_status = 0;
      const missionList = this.missionList[2] || [];
      this.missionList = {
        1: missionList.map(item => ({ ...item, status: 0 })),
        2: missionList.map(item => ({ ...item, status: 0 }))
      };
      this.answer = 0;
      this.is_red = false;
      this.reward_list = [0, 0, 0, 0, 0];
      this.share = false;
      this.time = 0;
      this.topic_list = [];
      this.topice_id = 1;
      this.join_periods = [];
      $("#turnpage").turn("page", 1);
    },
    // 随机获取题目
    getRandomQuestion() {
      return Math.floor(Math.random() * 40 + 1);
    },
    // 初始化第二期活动数据
    getFirstTravelData() {
      initSecondTravelData({ periods: 2 })
        .then(res => {
          if (res.code === 200) {
            const {
              answer,
              is_red,
              reward_list,
              share,
              time,
              topic_list,
              topice_id
            } = res.data;
            this.answer = Number(answer); // 目前答对了几题
            this.is_red = is_red; // 奖励是否领取
            this.reward_list = reward_list; // 奖励列表
            this.share = share; // 是否领取过分享奖励
            this.time = time; // 答题次数
            this.topic_list = topic_list; // 题目数组
            this.topice_id =
              topice_id === "0" ? this.getRandomQuestion() : Number(topice_id); // 题目id,0表示第一次答题
          } else if (res.code !== 401) {
            this.myToast(res.message);
          }
        })
        .catch(err => {
          this.myToast("服务器出错啦");
        });
    },
    // 提交答案
    answerQuestion(option, index) {
      if (this.answering) return;
      if (this.answer >= 5) {
        this.myToast("您已解锁所有答题奖励，请前往领取");
        return;
      }
      if (this.time <= 0) {
        this.myToast("今天没次数了，明天再来吧");
        return;
      }
      this.answering = true;
      const params = {
        topic_id: this.topice_id,
        answer: option
      };
      Indicator.open();
      this.choosedOption = index;
      answer(params)
        .then(res => {
          console.log("res", res);
          Indicator.close();
          if (res.code === 200) {
            const { is_correct, key, score, time } = res.data;
            if (is_correct && this.answer >= 4) {
              this.myToast("您已解锁所有答题奖励，请前往领取");
              this.answer = this.answer + 1;
              this.isRight = 1;
              this.answering = false;
              return;
            }
            if (is_correct) {
              this.answer = this.answer + 1;
              this.isRight = 1;
            } else {
              this.isRight = 2;
            }
            this.time = time;
            setTimeout(() => {
              this.topice_id = key;
              this.isRight = 0;
              this.choosedOption = -1;
              this.answering = false;
            }, 1000);
          } else {
            this.answering = false;
            this.myToast(res.message);
          }
        })
        .catch(err => {
          this.answering = false;
          Indicator.close();
          this.myToast("服务器出错啦");
        });
    },
    handleGetAnswerReward() {
      if (!this.userInfo.role_id) {
        this.myToast("请先登录", 1000);
        this.changeLoginPopup(true);
        return;
      }
      if (this.currentEndTip(2)) return;
      const index = this.reward_list.findIndex(item => item === 1);
      if (index < 0) {
        this.myToast("当前暂无可领取奖励哦！");
        return;
      }
      this.logger.sum("蜗牛全国巡游主题h5_第二期一键领取");
      getAnswerReward()
        .then(res => {
          if (res.code === 200) {
            this.myToast("领取成功");
            this.getFirstTravelData();
          }
        })
        .catch(() => {
          this.myToast("服务器出错啦");
        });
    },
    enterActivity(key) {
      const showTime = this.timeList[2].start;
      if (new Date(showTime).getTime() > new Date().getTime()) {
        this.myToast("活动尚未开启，预计于12月22日后开启");
        return;
      }
      const end = this.timeList[2].end;
      if (key === "wechat" && new Date(end).getTime() < new Date().getTime()) {
        this.myToast("活动已结束，感谢参与！");
        return;
      }
      this.logger.sum(`蜗牛全国巡游主题h5第二期_${key}`);
      setTimeout(() => {
        window.location.href = this.urlList[key];
      }, 300);
    },
    handleShowGameReward() {
      this.showGameIndex = false;
      this.showGameReward = true;
      this.showBtnGetReward = true;
    },
    // 分享图片
    openShare: _.throttle(
      function() {
        this.shareShow = true;
        // const page = $('#turnpage').turn('page')
        // Indicator.open()
        // generateCanvasImage(document.querySelectorAll(`#turnpage .page${page}`)[0])
        //   .then((canvas) => {
        //     Indicator.close()
        //     this.shareShow = true
        //     // this.shareImg = canvas.toDataURL('image/png') // 可将 canvas 转为 base64 格式
        //     console.log('success: 图片生成成功')
        //   })
        //   .catch((err) => {
        //     Indicator.close()
        //     console.log('err: 图片生成失败', err.message)
        //   })
      },
      1000,
      { trailing: false }
    ),
    // 关闭分享弹窗
    shareClose() {
      this.shareShow = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/riverMountain-2/enter${getTimeStamp()}`,
        title: "最强蜗牛华夏寻宝之旅启程！",
        imgUrl:
          "https://download4.qcplay.com/qcgame-admin/JpiFxKySEHpq4p21jn34ArDmE8PrFXL5kxSVqoZF.png",
        desc: "华夏寻宝之旅启程了，与蜗一起走遍祖国大地，寻找隐藏的秘宝！"
      });
    },
    ...mapMutations(["changeLoginPopup", "changeOsPopup", "setLogger"]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log("newValue", newValue);
        console.log("oldValue", oldValue);
        if (!newValue.role_id) {
          // TAG: 注销的时候
          console.log("注销的时候");
          this.osCancell();
        } else if (
          newValue.role_id !== oldValue.role_id ||
          newValue.account !== oldValue.account
        ) {
          // 数据初始化
          // this.getLoginContainer()
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/riverMountain-2/index/index.vue